import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';
import DeliveryLookup from '../../components/DeliveryLookup/DeliveryLookup';


export const initOrder = () => {
    return {
        type: actionTypes.INIT_ORDER
    };
};

export const initDriver = () => {
    return {
        type: actionTypes.INIT_DRIVER
    };
};

export const initSearchResults = () => {
    return {
        type: actionTypes.INIT_SEARCH_RESULTS
    };
};



export const updateOrder = (idToken, value) => {
    return {
        type: actionTypes.UPDATE_ORDER,
        idToken: idToken,
        value: value
    };
};

export const updateSearchCriteria = (value) => {
    return {
        type: actionTypes.UPDATE_SEARCH_CRITERIA,
        value: value
    };
};

export const setEditOrder = (id, orderData) => {
    return {
        type: actionTypes.SET_EDIT_ORDER,
        orderId: id,
        orderData: orderData
    };
};

export const setAddCallListOrder = (id, orderData) => {
    return {
        type: actionTypes.SET_ADD_CALLLIST_ORDER,
        orderId: id,
        orderData: orderData
    };
};

export const messageFail = (errorMessage) => {
    if (errorMessage === 'Security Exception') {
        return (dispatch) => {
            dispatch(logout());
        }

    }
    else {
        return {
            type: actionTypes.MESSAGE_FAIL,
            error: errorMessage,
            loading: false
        }
    }
};

export const loadStart = () => {
    return {
        type: actionTypes.LOAD_START
    };
};


export const getSalesSummary = (forUser) => {
    return (dispatch, getState) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/MulchOrder/GetSalesSummary?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&forUser=' + forUser;

        axios.post(url)
            .then(response => {
                if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    dispatch(loadResult('salesSummary', {
                        hardwoodBags: response.data.hardwoodBags,
                        cedarBags: response.data.cedarBags,
                        blackBags: response.data.blackBags,
                        redBags: response.data.redBags,
                        totalBags: response.data.totalBags
                    }));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const submitOrderSuccess = (id, orderData) => {
    return {
        type: actionTypes.SUBMIT_ORDER_SUCCESS,
        orderId: id,
        orderData: orderData
    };
};

export const deleteOrder = (orderId) => {
    return (dispatch, getState) => {
        let { orders } = getState().orders;
        dispatch(loadResult('deleted', false));
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/MulchOrder/DeleteOrder?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&orderId=' + orderId;

        axios.post(url)
            .then(response => {
                if (response.data == '') {

                    dispatch(loadResult('deleted', true));
                    const ords = [];

                    for (let k in orders) {
                        if (orders[k].orderId != orderId) {
                            ords.push(orders[k]);
                        }
                    }

                    dispatch(loadResultArray('orders', ords));
                    dispatch(getSalesSummary(false));
                }
                else if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    dispatch(messageFail(response.data));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const approveOrder = (orderId) => {
    return (dispatch, getState) => {
        let { orders } = getState().orders;
        dispatch(loadResult('updated', false));
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/MulchOrder/ApproveOrder?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&orderId=' + orderId;

        axios.post(url)
            .then(response => {
                if (response.data == '') {
                    dispatch(loadResult('updated', true));
                    const search = [];

                    for (let k in orders) {
                        if (orders[k].orderId == orderId) {
                            orders[k].status = 'approved'
                        }
                        search.push(orders[k]);
                    }

                    dispatch(loadResultArray('orders', search));
                }
                if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    dispatch(messageFail(response.data));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};


export const submitOrder = () => {
    return (dispatch, getState) => {
        let { order } = getState().orders;
        let { userId } = getState().orders;
        let { userType } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let touched = 'new';
        let touchedByAdmin = '';
        let uid = userId;
        if (userType == 'admin') {
            touched = '';
            touchedByAdmin = 'new';
            uid = order.userId;
        }
        else if (order.orderId > 0) {
            uid = order.userId;
        }

        let url = ('https://api.mescout.org/api/MulchOrder/AdminOrder?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&userId=' + uid + '&orderId=' + order.orderId + '&name=' + order.name + '&address=' + order.address + '&city=' + order.city + '&zip=' + order.zip +
            '&geoAddress=' + order.geoAddress + '&geoLon=' + order.geoLon + '&geoLat=' + order.geoLat +
            '&phone=' + order.phone + '&email=' + order.email + '&hardwoodBags=' + order.hardwoodBags +
            '&cedarBags=' + order.cedarBags + '&blackBags=' + order.blackBags + '&redBags=' + order.redBags +
            '&cyprusBags=0' +
            '&deliveryType=' + order.deliveryType + '&deliveryFee=0&donation=0&total=' + order.total +
            '&paymentStatus=' + order.paymentStatus + '&cashAmount=' + order.cashAmount + '&checkAmount=' + order.checkAmount +
            '&checkNumber=' + order.checkNumber + '&notes=' + order.notes + '&inDeliveryArea=' + order.isInArea +
            '&isSuspect=false&touched=' + touched + '&touchedByAdmin=' + touchedByAdmin);

        axios.post(url)
            .then(response => {
                if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else if (!response.data.orderId) {
                    dispatch(messageFail(response.data));
                }
                else {

                    //dispatch(submitOrderSuccess(response.data.orderId, order));
                    const { orders } = getState().orders;
                    const ords = [];
                    let found = false;
                    for (let k in orders) {
                        if (order.orderId > 0 && order.orderId == orders[k].orderId) {
                            ords.push(response.data);
                            found = true;
                        }
                        else {
                            ords.push(orders[k]);
                        }
                    }
                    if (!found) {
                        order.orderId = response.data.orderId
                        ords.push(response.data);
                    }
                    dispatch(loadResultArray('orders', ords));
                    dispatch(loadResult('order', response.data));
                    dispatch(loadResult('submitted', true));
                    
                }
            })
            .catch(error => {
                dispatch(messageFail(error));
            });
    };
};

export const submitAdminOrder = () => {
    return (dispatch, getState) => {
        let { order } = getState().orders;
        let { orders } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/MulchOrder/AddAdminOrder?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&userId=' + order.userId +
            '&name=' + order.name + '&address=' + order.address + '&city=' + order.city + '&zip=' + order.zip +
            '&geoAddress=' + order.geoAddress + '&geoLon=' + order.geoLon + '&geoLat=' + order.geoLat +
            '&phone=' + order.phone + '&email=' + order.email + '&hardwoodBags=' + order.hardwoodBags +
            '&cedarBags=' + order.cedarBags + '&blackBags=' + order.blackBags + '&redBags=' + order.redBags +
            '&cyprusBags=0' +
            '&deliveryType=' + order.deliveryType + '&deliveryFee=0&donation=0&total=' + order.total +
            '&paymentStatus=' + order.paymentStatus + '&cashAmount=' + order.cashAmount + '&checkAmount=' + order.checkAmount +
            '&checkNumber=' + order.checkNumber + '&notes=' + order.notes + '&inDeliveryArea=' + order.isInArea +
            '&isSuspect=false&touched=new&touchedByAdmin=');

        axios.post(url)
            .then(response => {
                if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else if (!response.data.orderId) {
                    dispatch(messageFail(response.data));
                }
                else {
                    order.orderId = response.data.orderId;
                    order.status = 'initial';
                    let ords = [];
                    for (let k in orders) {

                        ords.push(orders[k]);

                    }
                    ords.push(order);

                    dispatch(loadResultArray('orders', ords));
                    dispatch(submitOrderSuccess(response.data.orderId, order));
                    //dispatch(addOrderToOrders(response.data.orderId, order));
                }
            })
            .catch(error => {
                dispatch(messageFail(error));
            });
    };
};

export const submitEditOrderSuccess = (id, orderData) => {
    return {
        type: actionTypes.SUBMIT_EDIT_ORDER_SUCCESS,
        orderId: id,
        orderData: orderData
    };
};


export const submitEditOrder = () => {
    return (dispatch, getState) => {
        const { order } = getState().orders;
        let { userType } = getState().orders;
        let touched = order.touched;
        let touchedByAdmin = order.touchedByAdmin;

        if (userType == 'scout') {
            if (touched != 'new') {
                touched = 'updated'
            }
        }
        else {
            if (touchedByAdmin != 'new') {
                touchedByAdmin = 'updated';
            }
        }
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/MulchOrder/UpdateOrder?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&userId=' + order.userId + '&orderId=' + order.orderId + '&name=' + order.name + '&address=' + order.address + '&city=' + order.city +
            '&zip=' + order.zip +
            '&geoAddress=' + order.geoAddress + '&geoLon=' + order.geoLon + '&geoLat=' + order.geoLat +
            '&phone=' + order.phone + '&email=' + order.email + '&hardwoodBags=' + order.hardwoodBags +
            '&cedarBags=' + order.cedarBags + '&blackBags=' + order.blackBags + '&redBags=' + order.redBags +
            '&deliveryType=' + order.deliveryType + '&deliveryFee=0&total=' + order.total +
            '&paymentStatus=' + order.paymentStatus + '&cashAmount=' + order.cashAmount + '&checkAmount=' + order.checkAmount +
            '&checkNumber=' + order.checkNumber + '&notes=' + order.notes + '&inDeliveryArea=' + order.isInArea +
            '&isSuspect=false&touched=' + touched + '&touchedByAdmin=' + touchedByAdmin + '&cyprusBags=0');

        axios.post(url)
            .then(response => {
                if (response.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    const { orders } = getState().orders;
                    const currentOrders = [];

                    for (let key in orders) {
                        if (orders[key].orderId === order.orderId) {
                            currentOrders.push({
                                ...order,
                                id: order.orderdId
                            });

                        }
                        else {
                            currentOrders.push({
                                ...orders[key],
                                id: orders[key].orderdId
                            });
                        }
                    }

                    dispatch(updateExistingOrder(currentOrders));
                    dispatch(submitEditOrderSuccess(order.orderId, order));
                }
            })
            .catch(error => {

            });
    };
};


export const updateGeoCode = (address, city, zip, geoAddress) => {
    return (dispatch, getState) => {
        const { order } = getState().orders.order;
        address = address.replace('#', '%23');
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/MulchOrder/ValidateAddress?site=' + site + '&address=' + address + '&city=' + city + '&zip=' + zip);
        axios.post(url)
            .then(response => {
                dispatch(updateOrder('geoLat', response.data.geoLat));
                dispatch(updateOrder('geoLon', response.data.geoLon));
                dispatch(updateOrder('geoAddress', geoAddress));
                dispatch(updateOrder('isInArea', response.data.inDeliveryArea));
                dispatch(updateOrder('isSuspect', response.data.isSuspect));
            })
            .catch(error => {

            });
    }
};

export const fetchOrdersSuccess = (orders) => {
    return {
        type: actionTypes.FETCH_ORDERS_SUCCESS,
        orders: orders
    };
};

export const fetchOrders = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { orders } = getState().orders;
        const { ordersGot } = getState().orders;
        let getAll = true;
        if (ordersGot && orders.length > 0) {
            getAll = false;
        }
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetOrders?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&getAll=' + getAll)
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                const fetchedOrders = [];
                if (!getAll) {
                    for (let k in orders) {
                        fetchedOrders.push(orders[k]);
                    }
                }
                let found = false;
                for (let key in res.data) {
                    for (let key1 in fetchedOrders) {
                        if (fetchedOrders[key1].orderId === res.data[key].orderId) {
                            found = true;
                            if (res.data[key].touchedByAdmin === "updated") {
                                fetchedOrders[key1] = res.data[key];
                                break;
                            }
                            else {
                                fetchedOrders.splice(key1, 1);
                                break;
                            }
                        }
                    }
                    if (!found) {
                        fetchedOrders.push({
                            ...res.data[key],
                            id: res.data[key].orderdId
                        });
                    }

                }
                dispatch(loadResult('ordersGot', true));
                dispatch(loadResultArray('orders', fetchedOrders));
            }

            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const fetchScoutSummary = () => {
    return (dispatch) => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetScoutSummary?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    const summary = [];
                    for (let key in res.data) {
                        summary.push({
                                ...res.data[key],
                                id: res.data[key].userId
                            });
                    }
                    dispatch(loadResult('scoutSummary', summary));
                    dispatch(loadResult('loading',false));
                }                    
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const addPickup = (userId,hardwoodBags,cedarBags,blackBags,redBags) => {
    return (dispatch) => {        
        
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/AddPickup?site=' + site + '&sessionId=' + localStorage.getItem('token') + 
        '&userId=' + userId + 
        '&hardwoodBags=' + hardwoodBags + 
        '&cedarBags=' + cedarBags + 
        '&blackBags=' + blackBags + 
        '&redBags=' + redBags)
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    dispatch(loadResult('pickupCreated', true));
                    //dispatch(fetchScoutSummary());
                   
                }                    
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const fetchPickupSummary = () => {
    return (dispatch) => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetPickupSummary?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                    const summary = [];
                    for (let key in res.data) {
                        summary.push({
                                ...res.data[key],
                                id: res.data[key].userId
                            });
                    }
                    dispatch(loadResult('pickupSummary', summary));
                    dispatch(loadResult('loading',false));
                }                    
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};


export const fetchScoutOrdersSuccess = (orders) => {
    return {
        type: actionTypes.FETCH_SCOUTORDERS_SUCCESS,
        orders: orders
    };
};

export const fetchScoutOrders = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { orders } = getState().orders;
        const { scoutOrdersGot } = getState().orders;
        let getAll = true;
        if (scoutOrdersGot && scoutOrdersGot.length > 0) {
            getAll = false;
        }
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetScoutOrders?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&getAll=' + getAll)
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                const fetchedOrders = [];
                if (!getAll) {
                    for (let k in orders) {
                        fetchedOrders.push(orders[k]);
                    }
                }
                for (let key in res.data) {
                    if (getAll || (res.data[key].touchedByAdmin === 'new')) {
                        fetchedOrders.push({
                            ...res.data[key],
                            id: res.data[key].orderdId
                        });
                    }
                    else {
                        for (let key1 in fetchedOrders) {
                            if (fetchedOrders[key1].orderId === res.data[key].orderId) {
                                if (res.data[key].touchedByAdmin === "updated") {
                                    fetchedOrders[key1] = res.data[key];
                                    break;
                                }
                                else {
                                    fetchedOrders.splice(key1, 1);
                                    break;
                                }
                            }
                        }
                    }
                }

                dispatch(loadResultArray('orders', fetchedOrders));
                dispatch(loadResult('scoutOrdersGot', true));
            }})        
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const loadResult = (idToken, value) => {
    return {
        type: actionTypes.LOAD_RESULT,
        idToken: idToken,
        value: value
    };
};

export const loadResultArray = (idToken, value) => {

        return {
            type: actionTypes.LOAD_RESULT_ARRAY,
            idToken: idToken,
            value: value
        };
    };

export const getOrdersForApproval = (userId) => {
    return (dispatch) => {
        dispatch(loadStart());
        dispatch(initSearchResults());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetOrdersForApproval?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&UserId=' + userId)
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                const fetched = [];
                for (let key in res.data) {
                    fetched.push({
                        ...res.data[key],
                        id: res.data[key].orderdId
                    });
                }

                dispatch(loadResultArray('searchResults', fetched));
            }})
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const fetchCallList = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }

        axios.get('https://api.mescout.org/api/MulchOrder/GetCallList?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                const fetched = [];
                for (let key in res.data) {
                    fetched.push({
                        ...res.data[key],
                        id: res.data[key].orderdId
                    });
                }

                dispatch(loadResultArray('callList', fetched));
            }})
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};


export const searchAdminCallList = () => {
    return (dispatch, getState) => {
        const { searchCriteria } = getState().orders;
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }

        axios.get('https://api.mescout.org/api/MulchOrder/SearchAdminCallList?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&searchCriteria=' + searchCriteria)
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                const fetched = [];
                for (let key in res.data) {
                    fetched.push({
                        ...res.data[key],
                        id: res.data[key].orderdId
                    });
                }
                dispatch(loadResultArray('searchResults', fetched));
            }})
            .catch(err => {
                dispatch(messageFail(err));
            });
    };

};


export const addOrderToOrders = (id, orderData) => {
    return {
        type: actionTypes.ADD_ORDER_TO_ORDERS,
        orderData: orderData
    };
};

export const updateExistingOrder = (currentOrders) => {
    return {
        type: actionTypes.UPDATE_EXISTING_ORDER,
        orders: currentOrders
    };
}

export const getScouts = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { scouts } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Security/GetScouts?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                dispatch(loadResultArray('scouts', res.data));
            }})
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};
export const getScoutsForApproval = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { scouts } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/MulchOrder/GetScoutsForApproval?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then(res => {
                if (res.data == 'Security Exception') {
                    return (dispatch) => {
                        dispatch(logout());
                    };
                }
                else {
                dispatch(loadResultArray('scoutsWithApprovals', res.data));
            }})
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};
export const authSuccess = (token, userId, userType) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId,
        userType: userType
    };
};

export const driverPhoneValid = (value) => {
    return {
        type: actionTypes.DRIVER_PHONE_VALID,
        value: value
    }
}

export const driverPhoneInValid = (value) => {
    return {
        type: actionTypes.DRIVER_PHONE_INVALID,
        value: value
    }
}

export const updateSuccess = () => {
    return {
        type: actionTypes.UPDATE_SUCCESS
    };
}

export const deleteSuccess = () => {
    return {
        type: actionTypes.DELETE_SUCCESS
    };
}




export const signUpSuccess = (token, userId, userType) => {
    return {
        type: actionTypes.SIGNUP_SUCCESS,
        idToken: token,
        userId: userId,
        userType: userType
    };
};


export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userType');

    return {
        type: actionTypes.AUTH_LOGOUT
    };
};



export const auth = (userName, password, isSignup) => {
    return dispatch => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Security/Login?site=' + site + '&userName=' + userName + '&password=' + password;

        axios.post(url)
            .then(response => {
                if (response.data.UserId) {
                    localStorage.setItem('token', response.data.SessionId);
                    localStorage.setItem('userId', response.data.UserId);
                    localStorage.setItem('userType', response.data.UserType);
                    dispatch(authSuccess(response.data.SessionId, response.data.UserId, response.data.UserType));
                    if (response.data.UserType === "scout") {
                        dispatch(fetchScoutOrders());
                    }
                }
                else {
                    dispatch(messageFail('invalid user name or password'));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const signUp = (firstName, lastName, email, phone, password, userName) => {
    return dispatch => {
        dispatch(loadStart());
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'localhost';
        }
        let url = 'https://api.mescout.org/api/Security/SignUp?site=' + site + '&firstName=' + firstName +
            '&lastName=' + lastName + '&email=' + email + '&phone=' + phone +
            '&password=' + password + '&userName=' + userName;
        axios.post(url)
            .then(response => {

                if (response.data.UserId) {
                    localStorage.setItem('token', response.data.SessionId);
                    localStorage.setItem('userId', response.data.UserId);
                    localStorage.setItem('userType', response.data.UserType);
                    dispatch(signUpSuccess(response.data.SessionId, response.data.UserId, response.data.UserType));

                }
                else {
                    dispatch(messageFail(response.data));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};


export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        } else {
            const userId = localStorage.getItem('userId');
            const userType = localStorage.getItem('userType');
            dispatch(authSuccess(token, userId, userType));
            if (userType === 'scout') {
                dispatch(fetchScoutOrders());
            }
        }
    };
};

export const addDelivery = () => {
    return (dispatch , getState) => {
        let { deliveries } = getState().deliveries;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Delivery/AddDelivery?site=' + site;

        axios.post(url)
            .then(response => {
                if (response.data.deliveryId !== 0) {
                    dispatch(loadResult('delivery', response.data));
                    let addIt = true;
                    for (let l in deliveries.delivery) {
                        if (deliveries.delivery[l].deliveryId == response.data.deliveryId) {
                            addIt = false;
                        }
                    }
                    if (addIt) {
                        dispatch(addDeliveryToDeliveries(response.data));
                    }
                }
                else {
                    dispatch(messageFail(response.data.Message));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    }
}

export const addDeliveryToDeliveries = (delivery) => {
    return {
        type: actionTypes.ADD_DELIVERY_TO_DELIVERIES,
        delivery: delivery
    };
}

export const addOrderToDelivery = (deliveryId, orderId) => {
    return (dispatch, getState) => {
        let { orders } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Delivery/AddOrderToDelivery?site=' + site +
            '&deliveryId=' + deliveryId + '&orderId=' + orderId;

        axios.post(url)
            .then(response => {
                dispatch(loadResult('delivery', response.data));
                const ords = [];
                for (let k in orders) {
                   
                    if (orders[k].orderId == orderId) {
                        orders[k].deliveryId = deliveryId;
                    }
                    ords.push(orders[k]);
                }

                dispatch(loadResultArray('orders', ords));
            });

    }
}

export const getLog = () => {
    return (dispatch) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Security/GetLog?site=' + site;

        axios.post(url)
            .then(response => {
                dispatch(loadResultArray('mulchLog', response.data));
            });

    }
}


export const removeOrderFromDelivery = (deliveryId, orderId) => {
    return (dispatch, getState) => {
        let { orders } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Delivery/RemoveOrderFromDelivery?site=' + site +
            '&deliveryId=' + deliveryId + '&orderId=' + orderId + '&message=';

        axios.post(url)
            .then(response => {
                dispatch(loadResult('delivery', response.data));
                const ords = [];

                for (let k in orders) {
                    if (orders[k].orderId == orderId) {
                        orders[k].deliveryId = 0;
                    }
                    ords.push(orders[k]);
                }

                dispatch(loadResultArray('orders', ords));
            });

    }
}

export const assignDriverDelivery = (deliveryId,driverId) => {
    return (dispatch) => {
        
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/DeliveryDriver/AssignDriverDelivery?site=' + site + '&deliveryId=' + deliveryId + '&driverId=' + driverId)
            .then(res => {
                dispatch(loadResultArray('drivers', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};



export const getDrivers = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { drivers } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/DeliveryDriver/GetDrivers?site=' + site)
            .then(res => {
                dispatch(loadResultArray('drivers', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const getDeliveryLookup = (filter) => {
    return (dispatch) => {
        if (filter.length == 0) {
            let none =  []
            dispatch(loadResult('deliveryLookup',none))
        }
        else {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Delivery/DeliveryLookup?site=' + site + '&filter=' + filter)
            .then(res => {
                dispatch(loadResultArray('deliveryLookup', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
        }
    };
};

export const getDeliveryProgress = () => {
    return (dispatch) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Delivery/GetDeliveryProgress?site=' + site)
            .then(res => {
                dispatch(loadResultArray('deliveryProgress', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};


export const getDeliveries = () => {
    return (dispatch, getState) => {
        dispatch(loadStart());
        const { deliveries } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Delivery/GetDeliveries?site=' + site)
            .then(res => {
                dispatch(loadResultArray('deliveries', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const getDelivery = (deliveryId) => {
    return (dispatch, getState) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Delivery/GetDelivery?site=' + site + '&deliveryId=' + deliveryId)
            .then(res => {
                dispatch(loadResult('delivery', res.data));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const updateDriverStatus = (driverId,status) => {
    return (dispatch) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/DeliveryDriver/UpdateDriverStatus?site=' + site + '&driverId=' + driverId + '&status=' + status)
            .then(res => {
                
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
}


export const sendDeliveryToLoad = (deliveryId) => {
    return (dispatch) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/Delivery/UpdateDeliveryStatus?site=' + site + '&status=load&deliveryId=' + deliveryId)
            .then(res => {
                dispatch(loadResult('delivery', res.data));
                dispatch(updateDriverStatus(res.data.driverId,'load'));
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };

    
}

export const checkDriverPhone = (phone) => {
    return (dispatch, getState) => {
        const { driver } = getState().orders; 
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        axios.get('https://api.mescout.org/api/DeliveryDriver/CheckDriver?site=' + site + '&driverId=' + driver.driverId + '&phone=' + phone)
            .then(response => {
                if (response.data == false) {
                    dispatch(driverPhoneValid(phone));
                }
                else {
                    dispatch(driverPhoneInValid(phone));
                }
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };

} 

export const updateDriverData = ( idToken, value ) => {
    return {
        type: actionTypes.UPDATE_DRIVER_DATA,
        idToken: idToken,
        value: value
    };
};




export const updateDeliveryDriver = (deliveryId, driverId) => {
    return (dispatch, getState) => {
        let { deliveries } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/Delivery/UpdateDeliveryDriver?site=' + site +
            '&deliveryId=' + deliveryId + '&driverId=' + driverId;

        axios.post(url)
            .then(response => {
                dispatch(loadResult('delivery', response.data));
                const ords = [];

                for (let k in deliveries) {
                    if (deliveries[k].deliveryId == deliveryId) {
                        deliveries[k].driverId = driverId;
                    }
                    ords.push(deliveries[k]);
                }

                dispatch(loadResultArray('deliveries', ords));
            });

    }
}

export const getMulchYear = () => {
    return (dispatch,) => {
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = 'https://api.mescout.org/api/MulchOrder/GetMulchYear?site=' + site ;

        axios.post(url)
            .then(response => {             
                dispatch(loadResult('mulchYear',  response.data));                
            })
            .catch(err => {
                dispatch(messageFail(err));
            });
    };
};

export const addDriver = () => {
    return (dispatch, getState) => {
        let {driver} = getState().orders;
        let { drivers } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/DeliveryDriver/AddDriver?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&firstName=' + driver.firstName + '&lastName=' + driver.lastName + '&phone=' + driver.phone +
            '&numberOfBags=' + driver.numberOfBags);

        axios.post(url)
            .then(response => {
                if (!response.data.driverId) {
                    dispatch(messageFail(response.data));
                }
                else {
                    driver.driverId = response.data.driverId;
                    driver.status = 'ready';
                    let drvs = [];
                    for (let k in drivers) {

                        drvs.push(drivers[k]);

                    }
                    drvs.push(driver);

                    dispatch(loadResultArray('Drivers', drvs));
                    dispatch(addDriverSuccess());
                }
            })
            .catch(error => {
                dispatch(messageFail(error));
            });
    };
};

export const updateDriver = () => {
    return (dispatch, getState) => {
        let {driver} = getState().orders;
        let { drivers } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/DeliveryDriver/updateDriver?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&driverId=' + driver.driverId + '&firstName=' + driver.firstName + '&lastName=' + driver.lastName + '&phone=' + driver.phone +
            '&numberOfBags=' + driver.numberOfBags);

        axios.post(url)
            .then(response => {
                if (!response.data.driverId) {
                    dispatch(messageFail(response.data));
                }
                else {
                    let drvs = [];
                    for (let k in drivers) {
                        if (drivers[k].driverId == driver.driverId) {
                            drvs.push(driver);
                        }
                        else {
                            drvs.push(drivers[k]);
                        }
                    }
                    drvs.push(driver);

                    dispatch(loadResultArray('drivers', drvs));
                    dispatch(updateSuccess());
                }
            })
            .catch(error => {
                dispatch(messageFail(error));
            });
    };
};

export const loadDriver = (driverId) => {
    return (dispatch, getState) => {
        let {driver} = getState().orders;
        let { drivers } = getState().orders;
        
        let drv = null;

        for (let k in drivers) {
            if (drivers[k].driverId == driverId) {
                drv = drivers[k];
            }
        }

        dispatch(loadResult('driver', drv));        
    };
};

export const deleteDriver = (driverId) => {
    return (dispatch, getState) => {
        let { drivers } = getState().orders;
        let site = window.location.hostname;
        site = site.replace('mulch', '');
        if (site === '') {
            site = 'local';
        }
        let url = ('https://api.mescout.org/api/DeliveryDriver/deleteDriver?site=' + site + '&sessionId=' + localStorage.getItem('token') +
            '&driverId=' + driverId);

        axios.post(url)
            .then(response => {
                    let drvs = [];
                    for (let k in drivers) {
                        if (drivers[k].driverId == driverId) {
                        }
                        else {
                            drvs.push(drivers[k]);
                        }
                    }
       

                    dispatch(loadResultArray('drivers', drvs));
                    dispatch(deleteSuccess());
                
            })
            .catch(error => {
                dispatch(messageFail(error));
            });
    };
};

export const addDriverSuccess = () => {
    return {
        type: actionTypes.ADD_SUCCESS
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/orders.js